import React from 'react';

import { CommentaireResponseDto } from 'lib_api/lib/api/gen';

import { useCommentaires } from 'hooks/commentaires/useCommentaires';

import { Commentaire } from './Commentaire/Commentaire';

import './DisplayCommentaire.less';

interface DisplayCommentairesProps {
  dossierId: string;
}

export const DisplayCommentaires = ({
  dossierId,
}: DisplayCommentairesProps): React.ReactElement => {
  const { data: commentaires } = useCommentaires(dossierId);

  const commentaireList: CommentaireResponseDto[] = commentaires || [];

  return (
    <>
      {commentaireList.length > 0 ? (
        <div className="displayCommentaires">
          {commentaireList.map(commentaire => (
            <Commentaire
              key={commentaire.id}
              dossierId={dossierId}
              commentaire={commentaire}
              actionsEnabled={true}
            />
          ))}
        </div>
      ) : (
        <div className="displayCommentaires__empty">Aucun commentaire.</div>
      )}
    </>
  );
};
